// src/services/customerContact.service.ts
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";
import { IPersonLookupResponse } from "@/apps/merchant3/models/IPersonLookupResponse";
import documentTypes from "@/apps/person-registration/enums/DocumentTypes";

export const lookupPersonByPhoneNumber = async (
  cartTag: string,
  phoneNumber: string,
  email: string
): Promise<IPersonLookupResponse> => {
  const response = await jwtApiClient.post(M3_API().LOOKUP_PERSON, {
    phoneNumber: phoneNumber,
    cartTag: cartTag,
    email: email,
  });
  return response.data;
};

export const attemptKyc = async (
  cartTag: string,
  phoneNumber: string,
  dob: string
): Promise<IPersonLookupResponse> => {
  const response = await jwtApiClient.post(M3_API().ATTEMPT_KYC, {
    phoneNumber: phoneNumber,
    cartTag: cartTag,
    dob: dob,
  });
  return response.data;
};

export const lookupPersonByIdNumber = async (
  cartTag: string,
  idNumber: string
): Promise<IPersonLookupResponse> => {
  const response = await jwtApiClient.post(M3_API().LOOKUP_PERSON_ID, {
    cartTag: cartTag,
    idNumber: idNumber,
  });
  return response.data;
};

export const lookupPersonByIdNumberAndType = async (
  cartTag: string,
  idNumber: string,
  idType: string
): Promise<IPersonLookupResponse> => {
  const response = await jwtApiClient.post(M3_API().LOOKUP_PERSON_ID, {
    cartTag: cartTag,
    idNumber: idNumber,
    documentType: idType,
  });
  return response.data;
};

export const attemptKycIdNumber = async (
  cartTag: string,
  idNumber: string,
  dob: string
): Promise<IPersonLookupResponse> => {
  const response = await jwtApiClient.post(M3_API().ATTEMPT_KYC_ID_NUMBER, {
    cartTag: cartTag,
    idNumber: idNumber,
    dob: dob,
  });
  return response.data;
};

export const getIdentificationTypes = (
  country: string
): Array<{ code: string; label: string; country: string; weight: number }> => {
  return documentTypes
    .filter((docType) => docType.country === country)
    .map((docType) => ({
      code: docType.code,
      label: docType.translationKey,
      country: docType.country,
      weight: docType.weight || 0,
    }))
    .sort((a, b) => b.weight - a.weight);
};
